/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthIntegration } from './PalAuthIntegration';
import {
    PalAuthIntegrationFromJSON,
    PalAuthIntegrationFromJSONTyped,
    PalAuthIntegrationToJSON,
} from './PalAuthIntegration';

/**
 * 
 * @export
 * @interface FindAllPalAuthIntegrationsForLead200Response
 */
export interface FindAllPalAuthIntegrationsForLead200Response {
    /**
     * 
     * @type {Array<PalAuthIntegration>}
     * @memberof FindAllPalAuthIntegrationsForLead200Response
     */
    data?: Array<PalAuthIntegration>;
}

/**
 * Check if a given object implements the FindAllPalAuthIntegrationsForLead200Response interface.
 */
export function instanceOfFindAllPalAuthIntegrationsForLead200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllPalAuthIntegrationsForLead200ResponseFromJSON(json: any): FindAllPalAuthIntegrationsForLead200Response {
    return FindAllPalAuthIntegrationsForLead200ResponseFromJSONTyped(json, false);
}

export function FindAllPalAuthIntegrationsForLead200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllPalAuthIntegrationsForLead200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(PalAuthIntegrationFromJSON)),
    };
}

export function FindAllPalAuthIntegrationsForLead200ResponseToJSON(value?: FindAllPalAuthIntegrationsForLead200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(PalAuthIntegrationToJSON)),
    };
}

